import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { SnackbarComponent } from '@core/components/snackbar/snackbar.component';
import { SnackBarType } from '@enums';

@Injectable({
  providedIn: 'root'
})
export class SxSnackbarService {
  constructor(public snackbar: MatSnackBar) {}

  openSnackBar(message: string, action: string = '', snackBarType: string = SnackBarType.Info) {
    return this.snackbar.openFromComponent(SnackbarComponent, {
      duration: 3000,
      data: {
        message: message,
        action: action,
        snackbarType: snackBarType
      },
      panelClass: ['sx-snackbar']
    });
  }

  openValidationErrorSnackBar(message: string, title: string = '', validationErrors: any[] = null) {
    return this.snackbar.openFromComponent(SnackbarComponent, {
      duration: -1,
      data: {
        message: message,
        title: title,
        validationErrors: validationErrors,
        snackbarType: SnackBarType.Error
      },
      panelClass: ['sx-snackbar', 'sx-snackbar--red']
    });
  }

  openErrorSnackBar(message: string, title: string = '', duration?: number) {
    let snackbarConfig: MatSnackBarConfig = {
      data: {
        message: message,
        title: title,
        snackbarType: SnackBarType.Error
      },
      panelClass: ['sx-snackbar', 'sx-snackbar--red']
    };

    if (typeof duration !== 'undefined'){
      snackbarConfig = {...snackbarConfig, duration: duration}
    } 

    return this.snackbar.openFromComponent(SnackbarComponent, snackbarConfig);
  }
}
